import { FlowDefs, SvgFlow } from './diagrams/parts';

/**
 * 히어로 통합 아키텍처.
 * 랜딩의 5개 주제(Agent · Gateway · MCP Server · RAG · GraphRAG)를 한 장에 담아
 * 채널 → 오케스트레이션 → 게이트웨이 → 역량 → 데이터로 흐르는 계층 구조를 보여준다.
 */

interface ANodeProps {
  x: number;
  y: number;
  w: number;
  h: number;
  label: string;
  variant?: 'core' | 'cyan' | 'purple' | 'muted';
  size?: number;
}

function ANode({ x, y, w, h, label, variant = 'muted', size = 13 }: ANodeProps) {
  return (
    <g className={`ai-arch-node is-${variant}`}>
      <rect x={x} y={y} width={w} height={h} rx={12} />
      <text x={x + w / 2} y={y + h / 2 + 1} textAnchor="middle" dominantBaseline="middle" fontSize={size}>
        {label}
      </text>
    </g>
  );
}

export default function HeroArchitecture() {
  const id = 'arch';
  return (
    <svg className="ai-arch" viewBox="0 0 540 540" role="img" aria-label="통합 AI 인프라 아키텍처">
      <FlowDefs idPrefix={id} />

      {/* 채널 → 오케스트레이션 */}
      <SvgFlow idPrefix={id} color="cyan" d="M90,58 C 90,90 120,90 150,112" arrow={false} />
      <SvgFlow idPrefix={id} color="cyan" d="M270,58 L270,112" arrow={false} delay={0.3} />
      <SvgFlow idPrefix={id} color="cyan" d="M450,58 C 450,90 420,90 390,112" arrow={false} delay={0.6} />

      {/* 오케스트레이션 → 게이트웨이 */}
      <SvgFlow idPrefix={id} color="accent" d="M200,166 C 200,196 180,196 180,216" arrow={false} delay={0.2} />
      <SvgFlow idPrefix={id} color="accent" d="M270,166 L270,216" arrow={false} delay={0.4} />
      <SvgFlow idPrefix={id} color="accent" d="M340,166 C 340,196 360,196 360,216" arrow={false} delay={0.6} />

      {/* 게이트웨이 → 역량 */}
      <SvgFlow idPrefix={id} color="purple" d="M150,280 C 110,300 95,300 95,322" arrow={false} delay={0.3} />
      <SvgFlow idPrefix={id} color="purple" d="M270,280 L270,322" arrow={false} delay={0.5} />
      <SvgFlow idPrefix={id} color="purple" d="M390,280 C 430,300 445,300 445,322" arrow={false} delay={0.7} />

      {/* 역량 → 데이터 */}
      <SvgFlow idPrefix={id} color="cyan" d="M95,388 L95,432" arrow={false} delay={0.4} slow />
      <SvgFlow idPrefix={id} color="cyan" d="M270,388 L270,432" arrow={false} delay={0.6} slow />
      <SvgFlow idPrefix={id} color="cyan" d="M445,388 L445,432" arrow={false} delay={0.8} slow />

      {/* 채널 */}
      <ANode x={20} y={14} w={150} h={44} label="Chat" />
      <ANode x={195} y={14} w={150} h={44} label="App · Portal" />
      <ANode x={370} y={14} w={150} h={44} label="Agent · A2A" />

      {/* 오케스트레이션 */}
      <ANode x={20} y={112} w={500} h={54} label="AI Agent · Orchestration" variant="cyan" size={15} />

      {/* 게이트웨이 */}
      <ANode x={20} y={216} w={500} h={64} label="A2A · MCP Gateway" variant="core" size={17} />

      {/* 역량 */}
      <ANode x={20} y={322} w={150} h={66} label="MCP Server" variant="purple" />
      <ANode x={195} y={322} w={150} h={66} label="VectorDB · RAG" variant="purple" />
      <ANode x={370} y={322} w={150} h={66} label="GraphDB · GraphRAG" variant="purple" size={12} />

      {/* 데이터 */}
      <ANode x={20} y={432} w={150} h={46} label="공공데이터" />
      <ANode x={195} y={432} w={150} h={46} label="공공서비스" />
      <ANode x={370} y={432} w={150} h={46} label="문서 · 지식" />
    </svg>
  );
}
